function findToken() {
  const modulePage = $('.dynamicPageContainer .modulePageTextMedia');
  let isCustom = false;
  let tokenFinded = null;
  let tokenModule = null;
  const foundTokens = [];

  if (modulePage.length) {
    modulePage.each(function () {
      const moduleTitle = $(this).find('.moduleTitle > span').text();
      if (VALID_TOKENS.includes(moduleTitle.toLowerCase())) {
        isCustom = true;
        tokenFinded = moduleTitle.toLowerCase().replaceAll(/[{}]/g, '');
        tokenModule = $(this);

        foundTokens.push({
          tokenFinded: tokenFinded,
          tokenModule: tokenModule,
        });
      }
    });
  }

  return { isCustom, foundTokens };
}

function customMediaContainer() {
  const { isCustom, foundTokens } = findToken();

  if (isCustom && foundTokens.length > 0) {
    for (const item of foundTokens) {
      const tokenClass = `custom-media-module custom-media-module-${item.tokenFinded}`;
      $(item.tokenModule).parent('.entityContainerModule').addClass(tokenClass);
      $(item.tokenModule).find('.moduleTitle').remove();
    }
  }
}
export { customMediaContainer };
